module.exports = __webpack_public_path__ + "img/logoutDark.37d09d7f.svg";